import React from "react";
import { size } from "lodash";
import Warmups from "@radarly/components/navigation/navbar/warmups";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";

export function NavbarWarmups() {
  const locale = useCurrentUserLocale();
  const warmups = [];
  const onCancelWarmups = () => {
    console.error("on cancel warmups");
  };
  return (
    !!size(warmups) && (
      <Warmups
        warmups={warmups}
        onCancelWarmups={onCancelWarmups}
        locale={locale}
        pullRight
      />
    )
  );
}
